export default __webpack_public_path__ + "static/logo-7215a377b67a6875901246ad3950923e.png";